module.exports = __webpack_public_path__ + "static/media/moderate-severe.dbd6cd7b.png";